var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from 'react';
import styled from 'styled-components/native';
import { Icon } from '../../../components/Icons';
import IconWrapper from './IconWrapper';
import theme from '../../theme';
const ArrowIcon = styled((_a) => {
    var { theme, name } = _a, rest = __rest(_a, ["theme", "name"]);
    return <Icon name={name} {...rest}/>;
}) `
  font-size: ${({ theme }) => theme.tenPT};
  color: ${({ theme }) => theme.FormElements};
`;
ArrowIcon.defaultProps = {
    theme: {
        tenPT: theme.tenPT,
        FormElements: theme.FormElements,
    },
};
// TO DO: move this to compoents
const ArrowIconTouchable = ({ iconName, onPressIcon }) => (<IconWrapper touchable={onPressIcon !== undefined} onPress={onPressIcon}>
    <ArrowIcon name={iconName}/>
  </IconWrapper>);
ArrowIconTouchable.defaultProps = {
    iconName: '',
};
export default ArrowIconTouchable;
